import type React from 'react';

interface Props {
  title: string;
  intro?: string;
  align?: 'center' | 'left';
}

const SectionIntro: React.FC<Props> = ({ title, intro, align = 'center' }) => {
  const alignmentClasses =
    align === 'center' ? 'text-center mx-auto' : 'text-left';

  return (
    <div className={`max-w-2xl ${alignmentClasses}`}>
      <div className="mb-12 pt-20 pb-4">
        <h2 className="font-serif text-3xl md:text-4xl font-medium text-[#1c1c1c] tracking-tight leading-tight mb-5">
          {title}
        </h2>
        {intro ? (
          <p className="text-lg text-[#1c1c1c]/65 leading-relaxed max-w-xl mx-auto">
            {intro}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default SectionIntro;
